var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createKey" },
    [
      _vm.$route.query.isApp != 1
        ? _c("van-nav-bar", {
            attrs: { title: _vm.$t("9100163"), "left-arrow": "" },
            on: {
              "click-left": function($event) {
                return _vm.goHome()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "commont_body" }, [
        _c("form", { staticClass: "tabForm" }, [
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("9100128")) + " "),
              _c("span", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.note,
                  expression: "formData.note"
                }
              ],
              attrs: { placeholder: _vm.$t("9100129") },
              domProps: { value: _vm.formData.note },
              on: {
                blur: function(e) {
                  return (_vm.checkForm.note = !e.target.value)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "note", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.checkForm.note
              ? _c("div", { staticClass: "rule" }, [
                  _vm._v(_vm._s(_vm.$t("9100129")))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item" },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("9100130")))
              ]),
              _vm._v(" "),
              _c(
                "van-checkbox-group",
                {
                  staticStyle: { width: "100%", display: "flex" },
                  model: {
                    value: _vm.formData.result,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "result", $$v)
                    },
                    expression: "formData.result"
                  }
                },
                [
                  _c(
                    "van-checkbox",
                    {
                      attrs: {
                        name: "a",
                        checked: "",
                        disabled: "",
                        shape: "square"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("9100131")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-checkbox",
                    {
                      staticClass: "noDisabledCheack",
                      attrs: {
                        name: "b",
                        shape: "square",
                        "checked-color": "#FFC72B"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("9100132")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("9100133")))
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.whiteList,
                  expression: "formData.whiteList"
                }
              ],
              attrs: {
                name: "",
                id: "",
                cols: "30",
                rows: "10",
                placeholder: _vm.$t("9100134")
              },
              domProps: { value: _vm.formData.whiteList },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "whiteList", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.checkIp
              ? _c("div", { staticClass: "rule" }, [
                  _vm._v(_vm._s(_vm.$t("9100171")))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "foot-list" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("300166")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("·")]),
            _vm._v(" "),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("9100138")) } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("·")]),
            _vm._v(" "),
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("9100139")) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("·")]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.$t("9100147")))
              ]),
              _vm._v(_vm._s(_vm.$t("9100148")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("span", [_vm._v("·")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("9100140")))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.pageData && _vm.pageData.id
        ? _c("div", { staticClass: "footer editFooter" }, [
            _c(
              "div",
              { staticClass: "edit-button" },
              [
                _c(
                  "van-button",
                  {
                    staticClass: "cancel",
                    attrs: { color: "rgba(0, 0, 0, 0.10)" },
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300111")))]
                ),
                _vm._v(" "),
                _c(
                  "van-button",
                  {
                    attrs: {
                      color: _vm.editDisabled
                        ? "rgba(0, 0, 0, 0.10)"
                        : "#FFC72B",
                      disabled: _vm.editDisabled
                    },
                    on: { click: _vm.editForm }
                  },
                  [_vm._v(_vm._s(_vm.$t("9100164")))]
                )
              ],
              1
            )
          ])
        : !_vm.$route.query.id
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              { staticClass: "check" },
              [
                _c("van-checkbox", {
                  attrs: {
                    name: "b",
                    shape: "square",
                    "checked-color": "#FFC72B"
                  },
                  model: {
                    value: _vm.checked,
                    callback: function($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked"
                  }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("9100135")) +
                      "\n                "
                  ),
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.isRiskTip = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("9100170")) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "van-button",
                  {
                    attrs: {
                      type: "info",
                      color: _vm.createDisabled ? _vm.changeBgColor : "#FFC72B",
                      size: "large",
                      disabled: _vm.createDisabled
                    },
                    on: { click: _vm.createForm }
                  },
                  [
                    _c("span", { style: _vm.createdBtn }, [
                      _vm._v(_vm._s(_vm.$t("9100137")))
                    ])
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.Showprice,
            callback: function($$v) {
              _vm.Showprice = $$v
            },
            expression: "Showprice"
          }
        },
        [
          _c("p", { staticClass: "p" }, [
            _c("svg", [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "describe inline-block" }, [
            _vm._v("\n            " + _vm._s(_vm.$t("9100145")) + "\n        ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell inline-block" },
            [
              _c("van-button", { on: { click: _vm.goChargemoney } }, [
                _vm._v(_vm._s(_vm.$t("300102")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          attrs: { "close-on-click-overlay": false },
          model: {
            value: _vm.isRiskTip,
            callback: function($$v) {
              _vm.isRiskTip = $$v
            },
            expression: "isRiskTip"
          }
        },
        [
          _c("p", { staticClass: "modal-title" }, [
            _c("svg", [
              _c("use", { attrs: { "xlink:href": "#icon-tishi-2" } })
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("9100154")))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-content" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("9100151")))]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                · " +
                  _vm._s(_vm.$t("9100152")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                · " +
                  _vm._s(_vm.$t("9100153")) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sell" },
            [
              _c(
                "van-button",
                {
                  on: {
                    click: function() {
                      _vm.isRiskTip = false
                      _vm.checked = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("9100155")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tipModel",
          model: {
            value: _vm.verificationModel,
            callback: function($$v) {
              _vm.verificationModel = $$v
            },
            expression: "verificationModel"
          }
        },
        [
          _c("verification", {
            attrs: {
              isGoogle: !!_vm.resultObj.is2FA,
              type: _vm.resultObj.is2FA
                ? "google"
                : _vm.user.email
                ? "email"
                : "phone",
              interfaceType: "online",
              validationToken: _vm.resultObj.validationToken,
              userName: _vm.resultObj.is2FA
                ? ""
                : _vm.user.email
                ? _vm.user.email
                : _vm.user.phone,
              isGeet: false
            },
            on: { submitFun: _vm.submitFun, backFun: _vm.backFun }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-605bf28c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605bf28c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/apiKey/createKey.vue
// module id = M/YB
// module chunks = 0